import React from "react";
import { Card, Typography, Row, Col, Input } from "antd";
import "./EducentreDetailCard.less";

const EducentreDetailCard = ({
  teacher,
  subject,
  schedule,
  mode,
  batchSize,
  availableSeats,
  onClick,
}) => {
  const { Title, Text } = Typography;
  return (
    <Card className='educentre-detail-card' onClick={onClick}>
      <Col>
        <Row className='info-row'>
          <Col span={12}>
            <div className='info-label'>Teacher name</div>
            <div className='info-value'>{teacher}</div>
          </Col>
          <Col span={12}>
            <div className='info-label'>Subject</div>
            <div className='info-value'>{subject}</div>
          </Col>
        </Row>
        <Row className='info-row'>
          <Col span={12}>
            <div className='info-label'>Schedule</div>
            <div className='info-value'>{schedule}</div>
          </Col>
          <Col span={12}>
            <div className='info-label'>Mode</div>
            <div className='info-value'>{mode}</div>
          </Col>
        </Row>
        <Row className='info-row'>
          <Col span={12}>
            <div className='info-label'>Batch size</div>
            <div className='info-value'>{batchSize}</div>
          </Col>
          <Col span={12}>
            <div className='info-label'>Available seats</div>
            <div className='info-value'>{availableSeats}</div>
          </Col>
        </Row>
      </Col>
    </Card>
  );
};

export default EducentreDetailCard;
